export default [
    {
        id: 'bottomLeft',
        s: {
            x: {
                start: 285,
                maze: 285,
                finish: 302,
            },
            y: {
                start: 327,
                maze: 254,
                finish: 16,
            },
            diameter: {
                start: 6,
                finish: 24,
            },
            text: 'ИЗУЧАЕМ ПОТРЕБНОСТИ ВАШИХ\nКЛИЕНТОВ, ИСПОЛЬЗУЯ\nСОЦИОЛОГИЧЕСКИЕ МЕТОДЫ',
        },
        m: {
            x: {
                start: 569,
                maze: 543,
                finish: 686,
            },
            y: {
                start: 524,
                maze: 423,
                finish: 32,
            },
            diameter: {
                start: 11,
                finish: 24,
            },
            text: 'ИЗУЧАЕМ ПОТРЕБНОСТИ\nВАШИХ КЛИЕНТОВ, ИСПОЛЬЗУЯ\nСОЦИОЛОГИЧЕСКИЕ МЕТОДЫ',
        },
        l: {
            x: {
                start: 283,
                maze: 437,
                finish: 754,
            },
            y: {
                start: 398,
                maze: 239,
                finish: 32,
            },
            diameter: {
                start: 13,
                finish: 32,
            },
            text: 'ИЗУЧАЕМ ПОТРЕБНОСТИ\nВАШИХ КЛИЕНТОВ,\nИСПОЛЬЗУЯ\nСОЦИОЛОГИЧЕСКИЕ\nМЕТОДЫ',
        },
        xl: {
            x: {
                start: 447,
                maze: 547,
                finish: 1135,
            },
            y: {
                start: 466,
                maze: 290,
                finish: 32,
            },
            diameter: {
                start: 15,
                finish: 32,
            },
            text: 'ИЗУЧАЕМ ПОТРЕБНОСТИ ВАШИХ\nКЛИЕНТОВ, ИСПОЛЬЗУЯ\nСОЦИОЛОГИЧЕСКИЕ МЕТОДЫ',
        },
    },
    {
        id: 'bottomRight',
        s: {
            x: {
                start: 226,
                maze: 230,
                finish: 320,
            },
            y: {
                start: 302,
                maze: 374,
                finish: 600,
            },
            diameter: {
                start: 6,
                finish: 24,
            },
            text: 'СОЗДАЕМ РАБОТАЮЩИЕ\nПРОТОТИПЫ И ПРОВЕРЯЕМ\nГИПОТЕЗЫ НА ПОЛЬЗОВАТЕЛЯХ',
        },
        m: {
            x: {
                start: 466,
                maze: 460,
                finish: 696,
            },
            y: {
                start: 480,
                maze: 604,
                finish: 968,
            },
            diameter: {
                start: 11,
                finish: 24,
            },
            text: 'СОЗДАЕМ РАБОТАЮЩИЕ\nПРОТОТИПЫ И ПРОВЕРЯЕМ\nГИПОТЕЗЫ НА ПОЛЬЗОВАТЕЛЯХ',
        },
        l: {
            x: {
                start: 607,
                maze: 360,
                finish: 928,
            },
            y: {
                start: 347,
                maze: 427,
                finish: 704,
            },
            diameter: {
                start: 13,
                finish: 32,
            },
            text: 'СОЗДАЕМ РАБОТАЮЩИЕ\nПРОТОТИПЫ И ПРОВЕРЯЕМ\nГИПОТЕЗЫ\nНА ПОЛЬЗОВАТЕЛЯХ',
        },
        xl: {
            x: {
                start: 833,
                maze: 450,
                finish: 1328,
            },
            y: {
                start: 405,
                maze: 516,
                finish: 836,
            },
            diameter: {
                start: 15,
                finish: 32,
            },
            text: 'СОЗДАЕМ РАБОТАЮЩИЕ\nПРОТОТИПЫ И ПРОВЕРЯЕМ\nГИПОТЕЗЫ НА ПОЛЬЗОВАТЕЛЯХ',
        },
    },
    {
        id: 'topRight',
        s: {
            x: {
                start: 69,
                maze: 73,
                finish: 16,
            },
            y: {
                start: 327,
                maze: 415,
                finish: 600,
            },
            diameter: {
                start: 6,
                finish: 24,
            },
            text: 'ЗАПУСКАЕМ СЛОЖНЫЕ\nЦИФРОВЫЕ ПРОДУКТЫ',
        },
        m: {
            x: {
                start: 188,
                maze: 220,
                finish: 48,
            },
            y: {
                start: 524,
                maze: 674,
                finish: 968,
            },
            diameter: {
                start: 11,
                finish: 24,
            },
            text: 'ЗАПУСКАЕМ СЛОЖНЫЕ\nЦИФРОВЫЕ ПРОДУКТЫ',
        },
        l: {
            x: {
                start: 728,
                maze: 121,
                finish: 64,
            },
            y: {
                start: 398,
                maze: 485,
                finish: 704,
            },
            diameter: {
                start: 13,
                finish: 32,
            },
            text: 'ЗАПУСКАЕМ СЛОЖНЫЕ\nЦИФРОВЫЕ ПРОДУКТЫ',
        },
        xl: {
            x: {
                start: 977,
                maze: 149,
                finish: 80,
            },
            y: {
                start: 466,
                maze: 600,
                finish: 836,
            },
            diameter: {
                start: 15,
                finish: 32,
            },
            text: 'ЗАПУСКАЕМ СЛОЖНЫЕ\nЦИФРОВЫЕ ПРОДУКТЫ',
        },
    },
];
